import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Badge from "@mui/material/Badge";
import classes from "./ThemeConstElements.module.css";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import ThemeRadioButtons from "../ThemeRadioButtons/ThemeRadioButtons";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";
import { Link } from "react-router-dom";
import SyncIcon from "@mui/icons-material/Sync";
import useHttpFetch from "../../../hooks/useHttpFetch";
import { toast } from "react-toastify";
import { useState } from "react";
import PasswordOutlinedIcon from "@mui/icons-material/PasswordOutlined";
import MultiLanTxt from "../../UI/MultiLanTxt/MultiLanTxt";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import LanguageTogeler from "./LanguageTogeler";
import storePackageAccessResInIndexedDB from "../../../utils/cache/PackageAccess/storePackageAccessResInIndexedDB";

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
  ({ theme }) => ({
    border: `none`,
    backgroundColor: "transparent !important",
    color: "inherit !important",
    width: "100%",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  }),
);
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    sx={{ color: "inherit !important", fill: "currentColor !important" }}
    expandIcon={<ExpandMoreIcon sx={{ color: "inherit !important", fill: "currentColor !important" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "transparent !important",
  color: "inherit !important",
  fill: "currentColor !important",
  padding: "0",
  minHeight: "unset",
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "inherit !important",
    fill: "currentColor !important",
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
    color: "inherit !important",
    fill: "currentColor !important",
  },
  "& .MuiAccordionSummary-content": {
    margin: 0,
    color: "inherit !important",
    fill: "currentColor !important",
    // marginInlineEnd: theme.spacing(19),
  },
}));
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  color: "inherit !important",
  padding: "15px 0 0 0 !important",
  borderTop: "none",
}));
const ThemeConstElements = ({ changeTheme, theme }) => {
  const [expanded, setExpanded] = useState("");
  const [expandedParent, setExpandedParent] = useState("");
  const { isLoading, sendRequest } = useHttpFetch();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleChangeParent = (panel) => (event, newExpanded) => {
    setExpandedParent(newExpanded ? panel : false);
  };
  const refreshHandler = async (e) => {
    const result = await sendRequest({
      url: "RefreshPackageAccess",
      noMiddleUrl: true,
    });
    if (result.resIsOk) {
      console.log(result);
      const preferedData = {
        accessibilities: result.response,
      };
      await storePackageAccessResInIndexedDB(preferedData);
    } else {
      toast.error("به روز رسانی دسترسی‌ها با خطا مواجه شد");
    }
  };
  return (
    <div className={classes.container}>
      <Link to="/all">
        <div style={{ display: "flex", alignItems: "center", height: "48px" }}>
          <InboxOutlinedIcon sx={{ marginInlineEnd: "12px" }} />
          <MultiLanTxt tid="AllTasks" />
        </div>
      </Link>
      <Link to="/operation">
        <div style={{ display: "flex", alignItems: "center", height: "48px" }}>
          <InboxOutlinedIcon sx={{ marginInlineEnd: "12px" }} />
          <MultiLanTxt tid="OPERATION_LIST" />
        </div>
      </Link>
      <Link to="/drafts">
        <div style={{ display: "flex", alignItems: "center", height: "48px" }}>
          <SaveAsOutlinedIcon sx={{ marginInlineEnd: "12px" }} />
          پیش نویس
        </div>
      </Link>
      <Link to="/change-password">
        <div style={{ display: "flex", alignItems: "center", height: "48px" }}>
          <PasswordOutlinedIcon sx={{ marginInlineEnd: "12px" }} />
          تغییر رمز عبور
        </div>
      </Link>
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "48px",
        }}
      >
        <div>
          <Badge color="secondary" variant="dot" sx={{ marginInlineEnd: "12px" }}>
            <NotificationsNoneIcon />
          </Badge>
          اعلان‌ها
        </div>
        <div className={classes.Badge}>12</div>
      </div> */}
      <Accordion
        sx={{ color: "inherit !important", fill: "currentColor !important" }}
        expanded={expandedParent === "panel2"}
        onChange={handleChangeParent("panel2")}
      >
        <AccordionSummary
          sx={{ color: "inherit !important", fill: "currentColor !important" }}
          aria-controls="panel2d-content"
          id="panel2d-header"
        >
          <Typography
            sx={{ display: "flex", alignItems: "center", height: "48px", color: "inherit !important" }}
          >
            <SettingsOutlinedIcon sx={{ marginInlineEnd: "12px", color: "inherit !important" }} />
            تنظیمات
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            sx={{ paddingBlock: "1px 10px" }}
          >
            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
              <Typography sx={{ display: "flex", color: "inherit !important" }}>
                <PaletteOutlinedIcon sx={{ marginInlineEnd: "12px", color: "inherit !important" }} />
                تم رنگ
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                }}
              >
                <ThemeRadioButtons changeTheme={changeTheme} theme={theme} />
              </Typography>
            </AccordionDetails>
          </Accordion>
          <span style={{ display: "flex", alignItems: "center", height: "48px" }}>
            <LanguageIcon sx={{ marginInlineEnd: "12px" }} />
            <LanguageTogeler />
          </span>
          <span
            style={{ display: "flex", alignItems: "center", height: "48px", cursor: "pointer" }}
            onClick={refreshHandler}
          >
            <SyncIcon sx={{ marginInlineEnd: "12px" }} />
            <span>به روز رسانی دسترسی‌ها</span>
          </span>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ThemeConstElements;
